<div class="tw-relative tw-grid lg:tw-grid-cols-2 lg:tw-min-h-[41.5rem]">
   <button aria-label="Close" (click)="dismiss()" class="tw-border-0 tw-bg-transparent tw-p-1.5 tw-absolute tw-top-2 tw-right-2 tw-z-50">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
         <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6 6 18m12 0L6 6"/>
      </svg>
   </button>
   <div class="tw-hidden lg:tw-block tw-overflow-hidden tw-relative">
      <img ngSrc="/assets/images/login/auth-popup-img.png" fill class="tw-block tw-object-cover" alt="Image">
   </div>
   <div class="tw-relative tw-overflow-auto tw-scrollbar-thin [&::-webkit-scrollbar]:tw-w-[6px] [&::-webkit-scrollbar-track]:tw-bg-transparent [&::-webkit-scrollbar-thumb]:tw-bg-[#e2e8f0] [&::-webkit-scrollbar-thumb]:tw-rounded-full hover:[&::-webkit-scrollbar-thumb]:tw-bg-[#cbd5e1]">
      @switch (currentStep()) {
         @case ('login') {
            <app-login 
               [isInsidePopup]="true" 
               [headerText]="loginHeaderText"
               [subheaderText]="loginSubheaderText"
               [showFormDirectly]="showEmailLoginForm()"
               (showFormRequested)="showEmailLoginForm.set(true)"
               (loginSuccess)="onLoginSuccess()" 
               (signupRequested)="currentStep.set('signup'); showEmailSignupForm.set(false)">
            </app-login>
         }
         @case ('signup') {
            <app-signup 
               [isInsidePopup]="true" 
               [headerText]="signupHeaderText"
               [subheaderText]="signupSubheaderText"
               [showFormDirectly]="showEmailSignupForm()"
               (showFormRequested)="showEmailSignupForm.set(true)"
               (emailOtpSent)="onEmailOtpSent()"
               (loginRequested)="currentStep.set('login'); showEmailLoginForm.set(false)">
            </app-signup>
         }
         @case ('verify-email') {
            <app-verify-email 
               [isInsidePopup]="true"
               (emailVerified)="onEmailVerified()"
               (editEmailRequested)="currentStep.set('signup')">
            </app-verify-email>
         }
      }
   </div>
</div>